export default __webpack_public_path__ + "static/media/AxionSpinnyCircle.146577e1.svg";